<template>
  <section class="add-bill">
    <b-modal
      v-model="isShow"
      dialog-class="dialog-class"
      size="lg"
      centered
      @hidden="clearValueInput"
      :title="dataRefillForBill ? $t('ar_client_edit_pay') : $t('ar_client_add_pay')"
      hide-footer
    >
      <validation-observer ref="formRef">
        <b-row class="m-0 mt-1 mb-1">
          <b-col md="6">
            <b-form-group class="label-requires" :label="$t('ar_client_cashier')" label-cols="3">
              <validation-provider
                #default="{ errors }"
                :name="$t('ar_client_cashier')"
                rules="required"
              >
                <v-select
                  v-model="cashierVal"
                  :options="listDataCashier"
                  label="CashierName"
                  :placeholder="$t('ar_client_select_payer')"
                ></v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group class="label-requires" :label="$t('ar_client_payments')" label-cols="3">
              <validation-provider
                #default="{ errors }"
                :name="$t('ar_client_payments')"
                rules="required"
              >
                <b-form-select v-model="payerVal">
                  <b-form-select-option :value="null">{{
                    $t("ar_client_payments")
                  }}</b-form-select-option>
                  <b-form-select-option-group
                    v-for="(item, index) in listPayment[0].PaymentMethod"
                    :key="index"
                    :label="item.Name"
                  >
                    <b-form-select-option
                      v-for="(itemMethod, index) in item.TransactionCode"
                      :key="index"
                      :value="{ Group: item, Option: itemMethod }"
                    >
                      {{ itemMethod.Description }}
                    </b-form-select-option>
                  </b-form-select-option-group>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <!-- <v-select v-model="payerVal" :placeholder="$t('ar_client_select_payments')"></v-select> -->
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="m-0 mb-1">
          <b-col md="6">
            <b-form-group
              class="label-requires"
              :label="$t('ar_voucher_type_currency')"
              label-cols="3"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('ar_voucher_type_currency')"
                rules="required"
              >
                <v-select
                  v-model="typeCurrencyVal"
                  :options="listCurrencyLocalStorage"
                  :placeholder="$t('ar_client_select_type_currency')"
                  label="CurrencyCode"
                ></v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group class="label-requires" :label="$t('ar_client_input_money_number')" label-cols="3">
              <validation-provider
                #default="{ errors }"
                :name="$t('ar_client_input_money_number')"
                rules="required"
              >
                <b-form-input v-model="dataInputForm.Amount"></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- <b-row
        v-if="payerVal && payerVal.Group.Code === 'CREDIT'"
        class="m-0 mb-1"
      >
        <b-col md="12">
          <b-form-group :label="$t('ar_client_card_number')" label-cols="1">
            <b-form-input v-model="dataInputForm.CardNumber"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row> -->

        <b-row class="m-0 mb-1">
          <b-col md="12">
            <b-form-group :label="$t('ar_voucher_note')" label-cols="1">
              <b-form-textarea v-model="dataInputForm.Note"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>

      <div class="w-100 border-top d-flex justify-content-end align-items-center p-1">
        <b-button variant="primary" @click="acceptDataSave">
          {{ $t("ar_voucher_save") }}
        </b-button>
      </div>
    </b-modal>
  </section>
</template>
<style lang="scss">
.dialog-class {
  width: 726px;
}
</style>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  name: "ModalBoxAddBill",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    dataRefillForBill: {
      type: Object,
      default: null,
    },
    listDataCashier: {
      type: Array,
      default: [],
    },
    listPayment: {
      type: Array,
      default: [],
    },
    idPayment: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      listCurrencyLocalStorage: JSON.parse(localStorage.getItem("userData"))?.currency,
      dataInputForm: {
        ArPaymentId: 0,
        PaymentMethodId: 0,
        PaymentTypeCode: "",
        CardNumber: "",
        ExpirationDate: new Date(),
        PaymentGatewayCode: "",
        Qrcode: "",
        Amount: 0,
        CurrencyCode: "",
        Note: "",
        CashierCode: "",
      },
      casherVal: null,
      payerVal: null,
      typeCurrencyVal: null,

      noteVal: "",

      cashierVal: null,
    };
  },

  methods: {
    closeModal() {
      this.$emit("update:isShow", false);
    },
    acceptDataSave() {
      this.$refs.formRef.validate().then((success) => {
        if (success) {
          const convertedDataInputForm = {
            ...this.dataInputForm,
            Amount: Number(this.dataInputForm.Amount),
            CashierCode:cashierVal.Id,
            CurrencyCode:typeCurrencyVal.CurrencyCode
          };

          this.$emit(
            !this.dataRefillForBill ? "accept-data" : "accept-data-edit",
            convertedDataInputForm
          );
          this.$emit("update:isShow", false);
          this.clearValueInput();
        }
      });
    },
    clearValueInput() {
      this.typeCurrencyVal = null;
      this.payerVal = null;
      this.cashierVal = null;

      this.dataInputForm = {
        ArPaymentId: 0,
        PaymentMethodId: 0,
        PaymentTypeCode: "",
        CardNumber: "",
        ExpirationDate: "",
        PaymentGatewayCode: "",
        Qrcode: "",
        Amount: 0,
        CurrencyCode: "",
        Note: "",
        CashierCode: "",
      };
    },
  },
  watch: {
    isShow(value) {
      this.$emit("update:isShow", value);
      if (!value) {
        this.clearValueInput();
      }
    },
    dataRefillForBill(value) {
      if (value) {
        this.typeCurrencyVal = value.CurrencyCode;
        this.dataInputForm = value;
        this.cashierVal = value.CashierCode;
        
        this.payerVal = {
          Group: this.listPayment[0].PaymentMethod.find((p) => p.Id === value.PaymentMethodId),
          Option: this.listPayment[0].PaymentMethod.find((p) => p.Id === value.PaymentMethodId)
            ?.TransactionCode[0],
        }; /* {
          Group: {
            Code: "CASH",
            Id: 1,
            Name: "Tiền mặt",
            TransactionCode: [
              {
                Description: "POS Cash/ Tien mat",
                Taxs: [],
                TransactionCode: "9100#1",
                TransactionCode1: "9100",
                TransactionSubCode: "1",
              },
            ],
          },
          Option: {
            Description: "POS Cash/ Tien mat",
            Taxs: [],
            TransactionCode: "9100#1",
            TransactionCode1: "9100",
            TransactionSubCode: "1",
          },
        }; */
      }
    },
   /*  cashierVal(value) {
      this.dataInputForm.CashierCode = value.Id;
    },
    typeCurrencyVal(value) {
      this.dataInputForm.CurrencyCode = value.CurrencyCode;
    }, */
    payerVal(value) {
      this.dataInputForm.ArPaymentId = this.idPayment;
      this.dataInputForm.PaymentMethodId = value.Group.Id;
      this.dataInputForm.PaymentGatewayCode = value.Group.Code;
      this.dataInputForm.PaymentTypeCode = "1";
      this.dataInputForm.ExpirationDate = new Date();

      
    },
  },
};
</script>
